import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IConstructive } from './interfaces';

export const getConstructiveList = (data: IDynamicTableParams) => {
  return instance()
    .post<IConstructive[]>('/problem/list', data)
    .then((response) => response.data);
};

export const getConstructiveAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/problem/availableColumns')
    .then((response) => response.data);
};

export const getConstructiveAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/problem/availableGroupColumns')
    .then((response) => response.data);
};

export const loadConstructive = (problemId: number) => {
  return instance()
    .get<IConstructive>('/problem/load/' + problemId)
    .then((response) => response.data);
};

export const createConstructive = (constructive: IConstructive) => {
  return instance()
    .post<IConstructive>('/problem/save', constructive)
    .then((response) => response.data);
};

export const updateConstructive = (constructive: IConstructive) => {
  return instance()
    .post<IConstructive>(`/problem/${constructive.problemId}/update`, constructive)
    .then((response) => response.data);
};

export const deleteConstructive = (problemId: number) => {
  return instance()
    .post('/problem/archive', { problemId })
    .then((response) => response.data);
};

export const recoverConstructive = (problemId: number) => {
  return instance()
    .post('/problem/recover', { problemId })
    .then((response) => response.data);
};
